import { render, staticRenderFns } from "./u-select-underlined.vue?vue&type=template&id=161a6def&scoped=true&"
import script from "./u-select-underlined.vue?vue&type=script&lang=js&"
export * from "./u-select-underlined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161a6def",
  null
  
)

export default component.exports